// extracted by mini-css-extract-plugin
export default {"whatsApp":"whatsApp_whatsApp__94CWo","watsAppIcon":"whatsApp_watsAppIcon__m4Wt0","watsAppText":"whatsApp_watsAppText__UDSl7"};